import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { PrintService } from 'src/app/core/services/print.service';
import { Client } from 'src/app/shared/models/clients/client';
import { PaymentPlanEnum } from 'src/app/shared/models/clients/clientContract';
import { User, UserRole } from 'src/app/shared/models/users/user';

@Component({
  selector: 'app-print-client-summary',
  templateUrl: './print-client-summary.component.html',
  styleUrls: ['./print-client-summary.component.scss']
})
export class PrintClientSummaryComponent implements OnInit {
  client: Client;
  user: User;
  userRole = UserRole;
  paymentPlanEnum = PaymentPlanEnum;


  constructor(
    private printService: PrintService,
    private authService: AuthService,
  ) {
    this.client = this.printService.data;
  }

  ngOnInit(): void {
    this.user = this.authService.user;
    this.printService.onDataReady('Client Summary');
  }

}
